import { z } from "zod";

/** The part of every prefixed id after the prefix. New ids use base32 (see `ids/newId`). */
const idBody = z.string().regex(/^[a-z0-9]{12}$/);

export const tenantIdSchema = z.templateLiteral(["t_", idBody]);
export const messageIdSchema = z.templateLiteral(["m_", idBody]);
export const runIdSchema = z.templateLiteral(["r_", idBody]);
export const outboundIdSchema = z.templateLiteral(["o_", idBody]);
export const conversationIdSchema = z.templateLiteral(["c_", idBody]);
export const deliveryIdSchema = z.templateLiteral(["dlv_", idBody]);
export const apiKeyIdSchema = z.templateLiteral(["k_", idBody]);
export const customActionIdSchema = z.templateLiteral(["a_", idBody]);

export const SINGLETON_ACTION_IDS = ["hold", "ignore"] as const;
export const actionIdSchema = z.union([customActionIdSchema, z.enum(SINGLETON_ACTION_IDS)]);

export type TenantId = z.infer<typeof tenantIdSchema>;
export type MessageId = z.infer<typeof messageIdSchema>;
export type RunId = z.infer<typeof runIdSchema>;
export type OutboundId = z.infer<typeof outboundIdSchema>;
export type ConversationId = z.infer<typeof conversationIdSchema>;
export type DeliveryId = z.infer<typeof deliveryIdSchema>;
export type ApiKeyId = z.infer<typeof apiKeyIdSchema>;
export type CustomActionId = z.infer<typeof customActionIdSchema>;
export type ActionId = z.infer<typeof actionIdSchema>;
